import _ from 'lodash';

import { CONFIG_KEYS, isFeatureEnabled } from '../config';
import { APP_TYPE, APP_TYPES } from '../const/appConstants';
import en from './en.json';
import tw from './tw.json';

const TRANSLATION_KEYS = {
  [APP_TYPES.TAIWAN]: tw,
  [APP_TYPES.IRELAND]: en,
};

export const APP_TRANSLATIONS = TRANSLATION_KEYS[process.env.REACT_APP_LANG ?? APP_TYPE];

export const handleI18Error = (e) => console.log(`I18n error: ${e.message}`);

if (isFeatureEnabled(CONFIG_KEYS.BILINGUAL_ENABLED)) {
  const missedTranslations = [];

  _.map(APP_TRANSLATIONS, (_value, key) => {
    APP_TRANSLATIONS[key] = `${APP_TRANSLATIONS[key]} | ${en[key]}`;

    if (!en[key]) {
      missedTranslations.push(key);
    }
  });

  if (missedTranslations.length) {
    console.warn(`Missing EN translation for keys: '${JSON.stringify(missedTranslations, null, 1)}'`);
  }
}
